module.exports = __webpack_public_path__ + "why16.png?95fa71c339ac22dae330732afaefd438";